// to standardize the accuracy of location across ios and android
/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use LocationAccuracyEnum from application-types instead.
 */
export enum LocationAccuracyEnum {
  Fine = 'Fine',
  Coarse = 'Coarse',
}

// to standardize the availability of location access across ios and android
/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use LocationAvailabilityEnum from application-types instead.
 */
export enum LocationAvailabilityEnum {
  Foreground = 'Foreground',
  Background = 'Background',
}

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use LocationType from application-types instead.
 */
export type LocationType = {
  latitude: number;
  longitude: number;
  distance?: number;
  accuracy: LocationAccuracyEnum | null;
  availability: LocationAvailabilityEnum | null;
  noLocation: boolean;
  error:
    | Error
    | {
        // GeolocationError from @react-native-community/geolocation
        code: number;
        message: string;
        PERMISSION_DENIED: number;
        POSITION_UNAVAILABLE: number;
        TIMEOUT: number;
      }
    | null;
};

/**
 * @deprecated This interface is deprecated and should not be used in new code.
 * Use LocationHelperInterface from application-types instead.
 */
export interface LocationHelperInterface {
  location: {
    latitude: number;
    longitude: number;
  };

  requestPermission: () => Promise<boolean>;
  isLocationGranted: (
    availability?: LocationAvailabilityEnum
  ) => Promise<boolean>;
  isWatching: () => boolean;
  stopWatching: () => void;
  startWatching: ({
    showRequestModal,
    availability,
    disableLocationPrecision,
    ignoreProximity,
  }: {
    showRequestModal?: boolean;
    ignoreNag?: boolean;
    availability: LocationAvailabilityEnum;
    disableLocationPrecision?: boolean;
    ignoreProximity?: boolean;
  }) => Promise<void>;
  getDistance: ({
    longitude,
    latitude,
  }: {
    longitude: number;
    latitude: number;
  }) => string;
}
